import store from '../store';

export type OfferActions = 'decline' | 'counter' | 'accept' | 'send' | 'suggest';
export const getDefaultOfferAmount = (): null | number => {
  return store.getState().settings.default_offer_amount;
};
